export type rowCountPerPage = 20 | 50 | 100;

export const rowCountPerPageOptions: rowCountPerPage[] = [20, 50, 100];